import React from 'react'
import styled from 'styled-components'
import { device } from '../../theme/device'

const ButtonT = styled.button`
  background-color: ${props =>
    props.active
      ? props.theme.global.colors.inputDarkLight
      : props.theme.global.colors.baseBackground};
  color: ${props =>
    props.active
      ? props.theme.global.colors.invertTextStrong
      : props.theme.global.colors.text};
  align-self: ${props => props.alignSelf};

  border-radius: 3px;
  padding: 1.5rem 0px;
  /* text-transform: uppercase; */
  /* border: 2px solid
    ${props =>
    props.active ? props.toolColor : props.theme.global.colors.border}; */
  /* box-shadow: none; */
  border: 1.5px solid ${props => props.theme.global.colors.inputDarkLight};
  /* border: none;
  box-shadow: 0px 0px 1px 1px ${props => props.theme.global.colors.dark}; */
  font-weight: 700;
  /* border-radius: ${props => props.borderRadius}; */
  letter-spacing: 1px;
  cursor: pointer;
  outline: none;
  /* margin-top: ${props => props.mt} !important; */
  text-align: center;
  line-height: 1.4;
  flex: 1;
  &:hover {
    /* border: 2px solid ${props => props.theme.global.colors.dark}; */
    box-shadow: ${props =>
      `0px 0px 0px 1px ${props.theme.global.colors.inputDarkLight}`};
  }
  &:focus-visible {
    color: ${props => props.theme.global.colors.text};
    background-color: ${props => props.theme.global.colors.hoverBg};
  }
  @media ${device.medium} {
    font-size: 1.5rem;
  }
`

const InputButton = props => {
  return <ButtonT {...props}> {props.children}</ButtonT>
}

export default InputButton
